import Util from "../util";
import AguaSearchApi from "../agua-api/agua-search";
// https://github.com/krisk/Fuse/pull/423
// import Fuse from "fuse.js";
import Fuse from "fuse.js/dist/fuse.common.js";
import SimpleBar from "simplebar";

// File#: _1_side-navigation
// Usage: codyhouse.co/license

class AguaFabricSearchUI {
	aguaSearchApi;
	formData;
	requestUrl;

	constructor() {
		// Connect to the Search Api
		this.aguaSearchApi = new AguaSearchApi();

		// Setup the form
		this.form = document.querySelector("#agua-fabric-search");

		if (this.form === null) return;

		this.resultsWrapper = document.querySelector("#agua-fabric-search-results");
		this.requestUrl = this.form.action;

		this.formCheckboxes = this.form.querySelectorAll(".custom-checkbox__input");

		const fabricSelectFilter = document.getElementsByClassName("js-fabric-select-filter");

		var is_safari = navigator.userAgent.indexOf("Safari") > -1;

		if (fabricSelectFilter.length > 0) {

			if(is_safari){
				new SimpleBar(document.querySelector('.fabric-select-filter__menu-inner'), { 			autoHide: false
				});
			}
			for (var i = 0; i < fabricSelectFilter.length; i++) {



				this.showFilterContainer(fabricSelectFilter[i]);
			}
		}

		if (this.form !== null) {
			this.setupEvents();
		}
	}

	setupEvents() {
		this.form.addEventListener("change", (e) => {
			e.preventDefault();
			// send the request
			if (e.target.classList.contains("custom-checkbox__input")) {
				this.updateFilterStatus(e.target);
			}

			this.updateFabricResults();
		});
	}

	async updateFormCheckboxes() {
		if(this.form === null) return;

		this.formData = this.formData === undefined ? new FormData(this.form) : this.formData;

		try {
			const searchResults = await this.aguaSearchApi.getFabricsFromURL(this.requestUrl, this.formData);
			const filteredResults = await this.buildFilterJsonObject(searchResults);
			this.buildSearchFilterObjects(filteredResults);
		} catch (error) {
			console.error("updateFormCheckboxes", error);
			console.error("updateFormCheckboxes: Stack", error.stack);  // this will work on chrome, FF. will no not work on safari
			console.error("updateFormCheckboxes: this.requestUrl", this.requestUrl);
			console.error("updateFormCheckboxes: this.formData", this.formData);
		}

	}

	updateFilterStatus(currentCheckbox) {
		const searchFilter = currentCheckbox.closest(".fabric-select-filter");
		const checkedBoxes = searchFilter.querySelectorAll("input:checked");
		const checkedValue = searchFilter.querySelector(".fabric-select-filter__check-value");
		checkedValue.innerHTML = `&nbsp(${checkedBoxes.length})`;
	}

	showFilterContainer(selectFilter) {
		const btn = selectFilter.querySelector(".fabric-select-filter__button");

		btn.addEventListener("click", function (e) {
			e.preventDefault();
			const target = event.target.closest(".fabric-select-filter");
			const targetMenu = target.querySelector(".fabric-select-filter__menu");

			// Close other open menus
			const openMenus = document.querySelectorAll(".fabric-select-filter__menu--visible");

			if (openMenus.length > 0) {
				openMenus.forEach(function (menu) {
					// Double check its not 'this' menu
					if (menu !== targetMenu) {
						const bool = Util.hasClass(menu, "fabric-select-filter__menu--visible");
						Util.toggleClass(menu, "fabric-select-filter__menu--visible", !bool);
					}
				});
			}

			if (!targetMenu) return;

			// TODO: Set aria for accessiblilty
			// var listItem = btn.parentElement,
			const bool = Util.hasClass(targetMenu, "fabric-select-filter__menu--visible");
			// btn.setAttribute("aria-expanded", !bool);
			Util.toggleClass(targetMenu, "fabric-select-filter__menu--visible", !bool);
		});
	}

	async updateFabricResults() {
		this.formData = new FormData(this.form);

		try {
			const searchResultsHtml = await this.aguaSearchApi.requestResultHtml(this.requestUrl, this.formData);

			this.resultsWrapper.innerHTML = "-";
			this.resultsWrapper.innerHTML = searchResultsHtml;

			this.updateFormCheckboxes();

		} catch (error) {
			console.error('updateFabricResults', error);
		}
	}

	buildFilterJsonObject(list) {

		var fabricTypeCheckedList = document.querySelectorAll("[data-filter='fabric-type'] input:checked");
		var fabricColorCheckedList = document.querySelectorAll("[data-filter='fabric-color'] input:checked");
		var fabricCollectionCheckedList = document.querySelectorAll("[data-filter='fabric-collection'] input:checked");
		var fabricEnvCheckedList = document.querySelectorAll("[data-filter='fabric-environment'] input:checked");

		const fabricValuesMap = function (checkedItemsList) {
			return [...checkedItemsList].map((checkbox) => checkbox.dataset.value);
		};

		const fabricTypeValues = fabricValuesMap(fabricTypeCheckedList);
		const fabricColorValues = fabricValuesMap(fabricColorCheckedList);
		const fabricCollectionValues = fabricValuesMap(fabricCollectionCheckedList);
		const fabricEnvValues = fabricValuesMap(fabricEnvCheckedList);

		const options = {
			keys: ["fabricCollectionUrlTitle", "fabricColorTitle", "fabricTypeTitle", "fabricEnvironment"],
		};

		const fuseFilter = function (searchValues, fabricItems, fabricKey) {
			const fuseSearchIndex = new Fuse(fabricItems, options);

			const filteredDocs = fuseSearchIndex.remove((doc) => {
				if(typeof doc[fabricKey] === "object") {
					if(searchValues.indexOf(doc[fabricKey].join()) !== -1) {
						return doc;
					}
				} else {
					if(searchValues.indexOf(doc[fabricKey]) !== -1) {
						return doc;
					}
				}
			});

			return filteredDocs;
		};

		let searchResults = [...list.fabrics];

		if (fabricCollectionValues.length > 0) {
			searchResults = fuseFilter(fabricCollectionValues, searchResults, "fabricCollectionUrlTitle");
		}

		if (fabricTypeValues.length > 0) {
			searchResults = fuseFilter(fabricTypeValues, searchResults, "fabricTypeTitle");
		}

		if (fabricEnvValues.length > 0) {
			searchResults = fuseFilter(fabricEnvValues, searchResults, "fabricEnvironment");
		}

		if (fabricColorValues.length > 0) {
			searchResults = fuseFilter(fabricColorValues, searchResults, "fabricColorTitle");
		}

		if (searchResults.length === 0) {
			return list.fabrics;
		}

		return searchResults;
	}

	buildSearchFilterObjects(searchResults) {
		const fabricType = searchResults.reduce((c, { fabricTypeTitle: key }) => ((c[key] = (c[key] || 0) + 1), c), {});

		//----- FOR ENVIRONMENT OBJECT ----//

		const options = {
			keys: ["fabricEnvironment"],
			threshold: 0,
		};

		const fuseSearchIndex = new Fuse(searchResults, options);

		// https://stackoverflow.com/questions/11704267/in-javascript-how-to-conditionally-add-a-member-to-an-object/40560953#40560953
		const fabricEnvironment = {
			...fuseSearchIndex.search('interior').length > 0 && {interior: fuseSearchIndex.search('interior').length },
			...fuseSearchIndex.search('exterior').length > 0 && {exterior: fuseSearchIndex.search('exterior').length },
			...fuseSearchIndex.search('workplace').length > 0 && {workplace: fuseSearchIndex.search('workplace').length },
			...fuseSearchIndex.search('homeworker').length > 0 && {homeworker: fuseSearchIndex.search('homeworker').length }
		}

		//----- END ENVIRONMENT OBJECT ----//


		const fabricColor = searchResults.reduce((c, { fabricColorTitle: key }) => ((c[key] = (c[key] || 0) + 1), c), {});
		const fabricCollection = searchResults.reduce((c, { fabricCollectionUrlTitle: key }) => ((c[key] = (c[key] || 0) + 1), c), {});

		const fabricTypeEls = document.querySelectorAll("[data-filter='fabric-type']");
		const fabricEnvironmentEls = document.querySelectorAll("[data-filter='fabric-environment']");
		const fabricColorEls = document.querySelectorAll("[data-filter='fabric-color']");
		const fabricCollectionEls = document.querySelectorAll("[data-filter='fabric-collection']");

		// The issue is that as each property is selected that filter needs to be disabled

		const refreshCheckboxes = function (checkboxElementsList, fabricData) {
			checkboxElementsList.forEach((listItem) => {
				Util.removeClass(listItem, "fabric-select-filter__menu-item--disabled");
				const listItemCheckbox = listItem.querySelector("input");
				const listItemText = listItem.querySelector("span");

				const fabricDataValue = listItem.dataset.value;

				if (fabricData.hasOwnProperty(fabricDataValue)) {
					listItemCheckbox.disabled = false;

					listItemText.textContent = listItemText.textContent.replace(/([a-zA-Z0-9\s]{0,} )([0-9\(\)]{3,})/g, "$1(" + fabricData[fabricDataValue] + ")");
				} else {
					listItemCheckbox.disabled = true;
					listItemCheckbox.checked = false;

					listItemText.textContent = listItemText.textContent.replace(/([a-zA-Z0-9\s]{0,} )([0-9\(\)]{3,})/g, "$1(0)");
					Util.addClass(listItem, "fabric-select-filter__menu-item--disabled");
				}
			});
		};

		refreshCheckboxes(fabricTypeEls, fabricType);
		refreshCheckboxes(fabricColorEls, fabricColor);
		refreshCheckboxes(fabricCollectionEls, fabricCollection);
		refreshCheckboxes(fabricEnvironmentEls, fabricEnvironment);

		this.updateFilterStatus(fabricTypeEls[0]);
		this.updateFilterStatus(fabricEnvironmentEls[0]);
		this.updateFilterStatus(fabricColorEls[0]);
		this.updateFilterStatus(fabricCollectionEls[0]);
	}
}

export default AguaFabricSearchUI;
